import React from 'react'
import {View, TextInput, StyleSheet, Text, TouchableOpacity, ActivityIndicator, ScrollView} from 'react-native'
import {CustomTextInput} from './custom-text-input'
import {AppStorage} from './storage'
import {isPortrait} from '../orientation'
import {REACT_NATIVE_APIV2} from '../constants'

type Props = {
  cart: any,
  partner: string,
  onBack: Function,
  onCloseAfterSubmit: Function,
  extraAttributes: any,
}

class RFQData {
  firstName: string;
  lastName: string;
  email: string;
  number: string;
  business: string;
  comments: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  discount: string;

  constructor(firstName: string, lastName: string, email: string, number: string, business: string, comments: string, address1: string, address2: string, city: string, state: string, country: string, postalCode: string, discount: string) {
    this.firstName = firstName
    this.lastName = lastName
    this.email = email
    this.number = number
    this.business = business
    this.comments = comments
    this.address1 = address1
    this.address2 = address2
    this.city = city
    this.state = state
    this.country = country
    this.postalCode = postalCode
    this.discount = discount
  }
}

const Controls = ({onBack, onSubmit, state, spinner}: Props) => {
  const [showSubmit, setShowSubmit] = React.useState(false)
  React.useEffect(() => {
    let handle = setInterval(() => {
      if (state.firstName != "" && state.lastName != "" && state.email != "" && state.number != "") {
        setShowSubmit(true);
      } else {
        setShowSubmit(false);
      }
    }, 1000)

    return () => {
      clearInterval(handle)
    }
  }, [])

  return (
    <View
      style={styles.btnContainer}
    >
      <TouchableOpacity
          style={styles.addMoreBtn}
          onPress={onBack}
        >
        <Text style={styles.close}>Back</Text>
      </TouchableOpacity>
      {
        showSubmit &&
        <TouchableOpacity
            style={styles.addMoreBtn}
            onPress={onSubmit}

          >
          {
            spinner == true &&
            <ActivityIndicator />
          }
          {
            spinner === false &&
            <Text style={styles.close}>Submit</Text>
          }

        </TouchableOpacity>
      }

    </View>
  )
}

export const RFQForm = ({cart, partner, onBack, onCloseAfterSubmit, extraAttributes}: Props) => {
  const [spinner, setSpinner] = React.useState(false)
  let discount = null
  // if (partner === 'bsi' || partner === 'labrepco') {
  //   discount = '20%'
  // }

  var state = new RFQData(
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  )

  React.useEffect(() => {
    // check for discounts, if partner matches our promotion partners, add discount to purchase
    console.log(partner)
    // if (partner === 'bsi' || partner === 'labrepco') {
    //   state.discount = '20%'
    // }
    console.log(state.discount)
  }, [])

  const onSubmit = async () => {
    setSpinner(true)
    let discount = ''
    // if (partner === 'bsi' || partner === 'labrepco') {
    //   discount = '20%'
    // }
    const baseURL = REACT_NATIVE_APIV2
    const url = baseURL + '/server.php/api/quote?email=' + state.email
              + '&first=' + state.firstName + '&last=' + state.lastName
              + '&number=' + state.number + '&remark=' + state.comments
              + '&business=' + state.business
              + '&partner=' + partner
              + '&address1=' + state.address1
              + '&address2=' + state.address2
              + '&city=' + state.city
              + '&state=' + state.state
              + '&country=' + state.country
              + '&postal=' + state.postalCode

    try {
      const result = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(cart),
      })

      setSpinner(false)

      if (result.status == 201) {
        if (navigator.cookieEnabled) {
          onCloseAfterSubmit()
          await AppStorage.removeItem("@rfqCart")
        } else {
          onCloseAfterSubmit()
          window.parent.postMessage('Remove Cart', `${document.referrer}`)
        }
      } else {
        window.alert("Failed. Try again later.")
      }

    } catch(error) {
      console.log(error)
      setSpinner(false)
      window.alert("Failed. Try again later.")
    }

  }

  const onChangeText = (id, value) => {
    state[id] = value
  }

  const InnerBody = (props) => (
    <>
    <View style={styles.innerBody}>
      { props.discount && <Text style={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold', padding: '10px 10px 10px 10px' }}>{`Congratulations! You qualify for ${props.discount} off!`}</Text> }
      <View style={styles.requiredContainer}>
        <View style={styles.columnZero}>
          <CustomTextInput id="firstName" style={styles.textInput} placeholderTextColor="gray" placeholder="*First Name" onChangeText={onChangeText} />
          <CustomTextInput id="email" style={styles.textInput} placeholderTextColor="gray"  placeholder="*Email" onChangeText={onChangeText} />
        </View>
        <View style={styles.columnOne}>
          <CustomTextInput id="lastName" style={styles.textInput} placeholderTextColor="gray"  placeholder="*Last Name" onChangeText={onChangeText} />
          <CustomTextInput id="number" style={styles.textInput} placeholderTextColor="gray"  placeholder="*Phone Number" onChangeText={onChangeText} />
        </View>
      </View>
      {(extraAttributes?.easyForm != true) && <CustomTextInput id="business" style={styles.textInput} placeholderTextColor="gray"  placeholder="Business" onChangeText={onChangeText} />}
      {(extraAttributes?.easyForm != true) && <CustomTextInput id="comments" style={styles.textInput} placeholderTextColor="gray"  placeholder="Comments" onChangeText={onChangeText} />}
      {(extraAttributes?.easyForm != true) && <CustomTextInput id="address1" style={styles.textInput} placeholderTextColor="gray"  placeholder="Address 1" onChangeText={onChangeText} />}
      {(extraAttributes?.easyForm != true) && <CustomTextInput id="address2" style={styles.textInput} placeholderTextColor="gray"  placeholder="Address 2" onChangeText={onChangeText} />}
      {(extraAttributes?.easyForm != true) && <CustomTextInput id="city" style={styles.textInput} placeholderTextColor="gray"  placeholder="City" onChangeText={onChangeText} />}
      <View style={styles.requiredContainer}>
        <View style={styles.columnZero}>
          {(extraAttributes?.easyForm != true) && <CustomTextInput id="state" style={styles.textInput} placeholderTextColor="gray"  placeholder="State" onChangeText={onChangeText} />}
        </View>
        <View style={styles.columnOne}>
          {(extraAttributes?.easyForm != true) && <CustomTextInput id="country" style={styles.textInput} placeholderTextColor="gray"  placeholder="Country" onChangeText={onChangeText} />}
        </View>
      </View>
      {(extraAttributes?.easyForm != true) && <CustomTextInput id="postalCode" style={styles.textInput} placeholderTextColor="gray"  placeholder="Postal Code" onChangeText={onChangeText} />}
    </View>
    <Controls onBack={onBack} onSubmit={onSubmit} state={state} spinner={spinner} />
    </>
  )

  return isPortrait() ? (
    <View style={styles.container}>
      <InnerBody discount={discount} />
    </View>
  ) : (
    <ScrollView contentContainerStyle={styles.scrollViewContainer}>
      <InnerBody discount={discount} />
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  scrollViewContainer: {
    backgroundColor: "#F3F3F3",
    width: "100%",
    // marginTop: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    maxWidth: 1000,
  },
  container: {
    backgroundColor: "#F3F3F3",
    height: "100%",
    width: "100%",
    // marginTop: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    maxWidth: 1000,
    minWidth: '100%',
  },
  requiredContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  textInput: {
    backgroundColor: "white",
    height: 40,
    padding: 4,
    fontSize: 16,
    borderRadius: 4,
    margin: 10,
    color: "#000",
  },
  columnOne: {
    width: "50%",
  },
  columnZero: {
    width: "50%",
  },
  addMoreBtn: {
    margin: 20,
    marginBottom: isPortrait() ? 0 : 60,
    backgroundColor: '#111',
    borderRadius: 5,
    padding: 10,
    maxWidth: 150,
    textAlign: 'center',
    width: '100%',
  },
  close: {
    color: 'white',
    textAlign: 'center',
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    // margin: 10,
    width: '100%',
  },
  innerBody: {
    minWidth: isPortrait() == false ? '800px' : 0,
    marginTop: isPortrait() == false ? '100px' : 0,
  }
})
